import { h } from "vue"
import { useDialog, NButton} from 'naive-ui'
import { useI18n } from "vue-i18n";

export default function() {
  // 元件宣告
  const dialog = useDialog()
  const { t } = useI18n()

  // 內部
  function destroy() {
    dialog.destroyAll()
  }

  // method
  function crtDialog(titleText, cont) {
    dialog.create({
        class: 'eventDialog',
        style: {
          width: '300px',
          'text-align': 'center',
          'border-radius': '10px'
        },
        maskClosable: false,
        closable: false,
        showIcon: false,
        title: () => h('h3',{'style': 'text-align: center;width: 100%;margin: 0;'}, titleText),
        content: () => h('span',{'style': 'white-space: pre-line;'}, cont),
        action: () => h(NButton, { text: true, color: '#00c4fb', onClick: destroy }, () => t('ok'))
    })
  }
  return {
    crtDialog
  }
}